'use client';

import * as React from 'react';
import { YouTubeEmbed } from '@next/third-parties/google';
import { signInToDashboard } from 'components/sign-in-button';
import { IconPlayCircle } from 'icon/Media&devices/play-circle';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'ui';

export function Cta(): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="flex gap-3">
        <Dialog>
          <DialogTrigger asChild>
            <Button size="lg" type="button" variant="outline">
              <IconPlayCircle />
              Watch Demo
            </Button>
          </DialogTrigger>
          <DialogContent className="w-[95%] max-w-sm! sm:max-w-lg! md:max-w-2xl! lg:max-w-4xl!">
            <DialogHeader>
              <DialogTitle>Demo video from the creator</DialogTitle>
            </DialogHeader>
            <YouTubeEmbed videoid="Qw1OSKGVeIQ" style="max-width: 850px;" />
          </DialogContent>
        </Dialog>
        <Button onClick={signInToDashboard} size="lg" type="button">
          Try It Free
        </Button>
      </div>
    </div>
  );
}
